/* eslint-disable */
import React from "react";
import { Redirect } from "react-router-dom";
import { Typography } from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings";
import MasterDataManager from "./MasterDataManager";

export default function FinanceMasterDataView(props) {
  const currentUser = (() => {
    try {
      const u = localStorage.getItem("currentUser");
      return u ? JSON.parse(u) : null;
    } catch {
      return null;
    }
  })();

  const isFinanceAccount = (() => {
    if (!currentUser) return false;
    const userDepts = Array.isArray(currentUser.userDepartment)
      ? currentUser.userDepartment
      : Array.isArray(currentUser.userView?.userDepartment)
      ? currentUser.userView.userDepartment
      : [];

    const hasBudgetDep = userDepts.some(u => {
      const depKey = Number(u.departmentKey);
      return depKey === 102 || depKey === 135 || depKey === 157;
    });

    const isAdmin =
      currentUser?.roles?.includes("Admin") ||
      currentUser?.userName === "madarakung" ||
      userDepts.some(u => Number(u.departmentKey) === 108);

    return hasBudgetDep || isAdmin;
  })();

  if (!isFinanceAccount) {
    return <Redirect to="/finance/slip" />;
  }

  const subTab = props?.match?.params?.subTab || "project";

  return (
    <div style={{ padding: "20px 24px", fontFamily: '"Sarabun", "Tahoma", sans-serif' }}>
      <div style={{ marginBottom: "20px" }}>
        <Typography
          variant="h5"
          style={{
            fontWeight: "bold",
            color: "#1e3a8a",
            display: "flex",
            alignItems: "center"
          }}
        >
          <SettingsIcon style={{ marginRight: 10, fontSize: 32 }} />
          จัดการข้อมูลระบบกันเงิน
        </Typography>
        <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
          จัดการข้อมูลตั้งต้น ข้อมูลโครงการ แหล่งเงิน งบประมาณ กิจกรรม หมวดจัดซื้อ และคู่ค้า
        </Typography>
      </div>

      <MasterDataManager activeSubTab={subTab} />
    </div>
  );
}

